import React from 'react';
import PropTypes from 'prop-types';
import { appConfig } from '@ami/react/core';

const InventoryItemBadge = ({ inStock, isConsignment }) => (
  <div>
    {appConfig.isManagementApp && isConsignment && <div className="alert alert-info text-start p-2 mb-0">
      Consignment
    </div>}
    {!(appConfig.isManagementApp && isConsignment) && <span className="badge text-bg-secondary mt-1 p-2">
      {inStock ? 'In Stock' : 'Stock Run'}
    </span>}
  </div>
);

InventoryItemBadge.propTypes = {
  inStock: PropTypes.bool.isRequired,
};

export default InventoryItemBadge;
